/**
 * ShowLength.js
 * 
 * Displays the current segment length while drawing.
 * Converts distance to feet and inches (e.g., 12' 4").
 */

import { DrawingGlobals, LABELS } from "../../Global/variables";
import { formatFeetAndInches } from "../Labels";

export function showLength(point) {
    // Ensure label exists
    if (!LABELS.length || !LABELS.length.element) return;

    const points = DrawingGlobals.intersectionPoints;
    if (points.length < 1) return;

    // ✅ Use the last placed point as the start of the segment
    const start = points[points.length - 1];
    const distanceMeters = start.distanceTo(point);

    // Convert meters → feet
    const { text } = formatFeetAndInches(distanceMeters);

    // Update label text and make visible
    LABELS.length.visible = true;
    LABELS.length.element.innerText = text;

    // Position halfway between start and current point  
    LABELS.length.position.lerpVectors(start, point, 0.5);
}
